import React, {useEffect, useState} from "react";
import {deleteResource, getByIdResource} from "../../service/http-service";
import './ProfileSegmentStyle.css'
import DeleteModal from "../../ui/DeleteModal";
import Edit from '../../../assets/img/profile-images/Uredi-icon.png';
import Delete from '../../../assets/img/profile-images/Izbrisi-icon.png';
import Plus from '../../../assets/img/profile-images/Otvori-icon.png';
import Minus from '../../../assets/img/profile-images/Zatvori-icon.png';
import {DateLabelFormatter} from "../../ui/DateLabelFormatter";
import {GenericEditModalForm} from "./GenericEditModalForm";


export const ProfileScientificPaperSegment = ({candidate, isPreview}) => {

    const [resultListEmpty, setResultListEmpty] = useState(true);
    const [showOneElement, setShowOneElement] = useState(true);
    const [firstElementFromList, setFirstElementFromList] = useState({})
    const [candidateExistingList, setCandidateExistingList] = useState([]);
    const [updateScientificPapers, setUpdateScientificPapers] = useState(false)

    const [entity, setEntity] = useState({candidate: candidate});
    const [addEntity, setAddEntity] = useState(false);
    const [updateEntity, setUpdateEntity] = useState(false)

    const getCandidateExistingList = () => {
        getByIdResource('candidate_scientific_papers/get_by_candidate', candidate.id).then(data => {
            setCandidateExistingList(data.data);
            setFirstElementFromList(data.data[0])
            if(data.data && data.data.length > 1){
                if(isPreview){
                    setShowOneElement(false);
                }
                setResultListEmpty(false)
            } else if(data.data && data.data.length === 1){
                setResultListEmpty(false)
            }else {
                setResultListEmpty(true);
            }
        })
    }
    const confirmDelete = (data, url, refreshEntity, setRefreshEntity) => {
        deleteResource(url, data).then(() =>{
            setRefreshEntity(!refreshEntity);
        }).catch((error) => {
            console.log('error')
        })
    }
    useEffect(()=> {
        getCandidateExistingList();
    },[])

    useEffect(() => {
        getByIdResource('candidate_scientific_papers/get_by_candidate', candidate.id).then(data => {
            setCandidateExistingList(data.data);
        })
    }, [updateEntity, updateScientificPapers])



    return(
        <div className='profile_segment_main_container'>
            {firstElementFromList && (candidateExistingList && candidateExistingList.length > 0) && showOneElement ?
                <div className='profile_segment_separate_info d-flex justify-content-between'>
                   <div>
                       {firstElementFromList.name &&  <h5>Назив на научниот труд: {firstElementFromList.name}</h5>}
                       {firstElementFromList.publishedIn && <p>Место на објавување:<span> {firstElementFromList.publishedIn}</span></p>}
                       {firstElementFromList.publishDate &&
                           <p>Датум на издавање: <DateLabelFormatter dateString={firstElementFromList.publishDate}/></p>}
                   </div>
                   <div className="icons-div justify-self-end">
                       {!isPreview &&  <div className="edit_delete_icons">
                           <img src={Edit} alt="edit" onClick={() => {
                               setShowOneElement(false)
                               setEntity(firstElementFromList)
                               setAddEntity(true)}
                           }/>
                           <DeleteModal btnText={<img src={Delete} alt="delete"/>}  btnClass="apply-btn" confirmDelete={() =>
                               confirmDelete(firstElementFromList, 'candidate_scientific_papers', updateScientificPapers, setUpdateScientificPapers)}/>
                       </div>}
                   </div>

                </div> :
                candidateExistingList.map(entity => <>
                    <div className='profile_segment_separate_info d-flex justify-content-between' key={entity.id}>
                       <div>
                           {entity.name &&  <h5>Назив на научниот труд: {entity.name}</h5>}
                           {entity.publishedIn && <p>Место на објавување:<span> {entity.publishedIn}</span></p>}
                           {entity.publishDate &&
                               <p>Датум на издавање: <DateLabelFormatter dateString={entity.publishDate}/></p>}
                       </div>
                       <div className="icons-div justify-self-end">
                           {!isPreview && <div className="edit_delete_icons">
                               <img src={Edit} alt="edit" onClick={() => {
                                   setShowOneElement(false)
                                   setEntity(entity)
                                   setAddEntity(true)}
                               }/>
                               <DeleteModal btnText={<img src={Delete} alt="delete"/>}  btnClass="apply-btn" confirmDelete={() =>
                                   confirmDelete(entity, 'candidate_scientific_papers', updateScientificPapers, setUpdateScientificPapers)}/>
                           </div>}
                       </div>
                    </div>
                <hr/>
                </>
                )}

            {!isPreview && !addEntity && (!showOneElement || resultListEmpty ) && (<div className="profile_add_button mt-3"
                                                                                        onClick={() =>
                                                                                        {setEntity({...entity, candidate: candidate})
                                                                                            setAddEntity(true)}}
            >Додади научен труд</div>)}
            {addEntity === true && (<div className="open-form"><GenericEditModalForm
                type="SCIENTIFIC_PAPER"
                title= {!entity.id ? "Додади научен труд" : "Уреди научен труд"}
                entity={entity} setEntity={setEntity}
                addEntity={addEntity} setAddEntity={setAddEntity}
                updateEntity={updateEntity} setUpdateEntity={setUpdateEntity}/></div>)}

            {(!isPreview && !resultListEmpty) &&
                <>
                    <div className='profile_plus_container'><hr/>
                        {showOneElement ?  <img src={Plus} alt='plus' onClick={()=> setShowOneElement(false)}/> :
                            <img src={Minus} alt='plus' onClick={()=> {
                                setShowOneElement(true)
                            setAddEntity(false)}}/>}
                    </div>
                </>
            }
        </div>
    )
}